module.exports = __webpack_public_path__ + "static/media/add.d871b25f.svg";